'use strict';

function LoanApplicationCompleteError() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController, _BankController];

  this.init = function () {
    this._super();
    this._$lastStepBtn = $('.js--loan-application--go-to-dashboard');
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    var _this = this;

    this._loanApplicationBankId = this._loanApplications[0].getBankId();
    this._loanApplicationAbsStatus = this._loanApplications[0].getAbsStatus();

    this._$lastStepBtn.on('click', function () {
      return _this._history.goToUrl(_this.paths.loans.application_status);
    });

    this._pushAnalytics();
    // Remove Page Progress loader
    this._removeProgressLoader();
  };

  this.destroy = function () {
    this._super();
  };

  this._removeProgressLoader = function () {
    // Progress Loader
    this._$loanApplicationFlowLoader = $('.js--progress-loader');
    this._$loanApplicationBody = $('.js--loan-application-body-content');

    // Hide page loader
    this._$loanApplicationFlowLoader.addClass('hide');
    this._$loanApplicationBody.removeClass('hide');
  };

  this._pushAnalytics = function () {
    var _this2 = this;

    // Bank Controller method
    this.getBankById(this._loanApplicationBankId, function (bankObj) {
      var bankName = bankObj.getBankName();

      _this2.analytics.forcePushEvent('abs-status', {
        Status: [_this2._loanApplicationAbsStatus],
        ABSBank: [bankName]
      });
    });
    // Status first and then page view, as per analytics
    this.analytics.forcePushEvent('virtual-page-view');
    this.analytics.forcePushEvent('mogo-money-status', null, this);
  };
}